import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './Logo.module.css';

function Logo() {
  const { logoImageSrc, logoImageAlt, showLogoImage, logoImageMaxHeight } =
    useSearchParamOrDefaultProps();

  const imgStyle = { maxHeight: logoImageMaxHeight };

  return (
    showLogoImage === 'true' && (
      <figure className={styles.logoWrapper}>
        <img
          style={imgStyle}
          className={styles.logo}
          src={logoImageSrc}
          alt={logoImageAlt}
        />
      </figure>
    )
  );
}

Logo.displayName = 'Logo';

export default Logo;
